import { render, staticRenderFns } from "./SmartGuideDetails.vue?vue&type=template&id=c46d9e2a&scoped=true&"
import script from "./SmartGuideDetails.vue?vue&type=script&lang=ts&"
export * from "./SmartGuideDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46d9e2a",
  null
  
)

export default component.exports